import { Platform, StyleSheet } from 'react-native';

const registeredStyles: { original: any; created: any }[] = [];

// React Native can register styles as numeric IDs. Mutating those registered
// values at runtime breaks Expo Go, so only keep mutable style tracking on web.
const originalCreate = StyleSheet.create;
if (Platform.OS === 'web') {
  StyleSheet.create = ((styles: any) => {
    const cloned = JSON.parse(JSON.stringify(styles));
    const created = originalCreate(cloned);
    registeredStyles.push({ original: JSON.parse(JSON.stringify(styles)), created });
    return created;
  }) as any;
}

const colorMappings: Record<string, string> = {
  '#F8FAFC': '#0B1120', // main background
  '#F5F7FA': '#0B1120', // alternate main background
  '#FFFFFF': '#141B2D', // surface / card / header / tabBar
  '#FFF': '#141B2D',
  '#F1F5F9': '#1E293B', // borderLight / chatBubbleOther
  '#E2E8F0': '#1E293B', // border
  '#DBEAFE': '#1E3A8A', // brandLight -> dark blue
};

const textMappings: Record<string, string> = {
  '#0F172A': '#F1F5F9', // textPrimary -> light text
  '#0A1C30': '#F1F5F9', // alternative textPrimary
  '#475569': '#94A3B8', // textSecondary -> slate 400
  '#94A3B8': '#64748B', // textTertiary -> slate 500
  '#0C5ADB': '#60A5FA', // brandPrimary text -> lighter blue
};

export function applyMobileTheme(mode: 'light' | 'dark') {
  if (Platform.OS !== 'web') return;

  for (const { original, created } of registeredStyles) {
    updateStyleObject(created, original, 'light');
  }
}

function updateStyleObject(created: any, original: any, mode: 'light' | 'dark') {
  if (!created || !original) return;

  for (const key of Object.keys(original)) {
    const origVal = original[key];
    const createdVal = created[key];

    if (createdVal && typeof createdVal === 'object') {
      // Nested style sheet item
      updateStyleObject(createdVal, origVal, mode);
    } else if (typeof origVal === 'string') {
      // Check if it's a color property or color value
      const isColorProp = key.toLowerCase().includes('color') || key === 'tintColor';
      const isTextProp = key === 'color'; // Only text 'color' gets mapped with textMappings

      let newVal = origVal;
      if (mode === 'dark') {
        if (isTextProp) {
          // If text is white, keep it white
          if (origVal === '#FFFFFF' || origVal === '#FFF') {
            newVal = origVal;
          } else {
            const upperVal = origVal.toUpperCase();
            newVal = textMappings[upperVal] || textMappings[origVal] || origVal;
          }
        } else if (isColorProp) {
          const upperVal = origVal.toUpperCase();
          newVal = colorMappings[upperVal] || colorMappings[origVal] || origVal;
        }
      } else {
        // Light mode - revert to original values
        newVal = origVal;
      }

      // Update the property in place
      created[key] = newVal;
    }
  }
}
